const colors = {
  white: '#fff',
  black: '#1E1E1E',
  primary: '#2FD086',
  primaryDark: '#009F77',
  secondary: '#0057FF',
  blue4: 'rgba(62, 63, 108, 0.8)',
  blue3: 'rgba(62, 63, 108, 0.6)',
  blue2: 'rgba(62, 63, 108, 0.4)',
  blue1: 'rgba(62, 63, 108, 0.2)',
  black4: 'rgba(0, 0, 0, 0.8)',
  black3: 'rgba(0, 0, 0, 0.6)',
  black2: 'rgba(0, 0, 0, 0.4)',
  black1: 'rgba(0, 0, 0, 0.2)',
  red: '#eb5c4d',
  orange: '#eb6153',
  yellow: '#ffca7d',

  gray: '#666666',
  grayLighter: '#979797',
  grayDark: '#333333',
  manatee: '#D9D9D9',
  grayLight: '#999999',
  bgYellowLight: '#fff9f2',
  bgGrayLight: '#fafafb',
  grayLightest: '#c9ccd4'
};

export default colors;
